export default __webpack_public_path__ + "static/media/170.7fecc38f.jpg";